import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

interface CreateFolderPayload {
  ownerid: number
  name: string
  description: string
  updatedAt: string
}
type CreateFolderResponse = CreateFolderPayload

export async function createFolder(
  payload: CreateFolderPayload,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.post<CreateFolderResponse>(
    apiRoutes.createFolder,
    payload,
    options,
  )

  return data
}
